import '../node_modules/bootstrap/dist/js/bootstrap.bundle.js';
import '../node_modules/slick-carousel/slick/slick.js';
import '../node_modules/jquery-match-height/jquery.matchHeight.js';
import '../node_modules/jquery-inview/jquery.inview.js';
import Handlebars from '../node_modules/handlebars/dist/handlebars.js';
window.Handlebars = Handlebars;
import 'pivot-base.js';

jQuery( document ).ready( function( $ ) {

  var isIE = /Trident\/|MSIE/.test(window.navigator.userAgent);

  //$('body').addClass('pd-menu-open');

  function string_to_slug (str) {
    str = str.replace(/^\s+|\s+$/g, ''); // trim
    str = str.toLowerCase();

    // remove accents, swap ñ for n, etc
    var from = "àáäâèéëêìíïîòóöôùúüûñç·/_,:;";
    var to   = "aaaaeeeeiiiioooouuuunc------";
    for (var i=0, l=from.length ; i<l ; i++) {
        str = str.replace(new RegExp(from.charAt(i), 'g'), to.charAt(i));
    }

    str = str.replace(/[^a-z0-9 -]/g, '') // remove invalid chars
        .replace(/\s+/g, '-') // collapse whitespace and replace by -
        .replace(/-+/g, '-'); // collapse dashes

    return str;
}

  if($('body').hasClass('home')){
    $('.pd-main-menu-wrap').addClass('clear');
    if($('.pd-mk-hero__video').length){
      $('.pd-main-menu-wrap').addClass('has-video-bg');
    }
    window.addEventListener('scroll', stickyHeader);
  }

  $('#pd-outer').prepend('<div class="pd-main-menu-bg" id="pdMainMenuBg"></div>');

  // COVID Banner
  // if($('.info-banner').length){
  //   $('.pd-main-menu-wrap').css('top', '48px');
  //   if(window.innerWidth < 768){
  //     $('#pd-outer').css('margin-top', '27px');
  //     $('.pd-toolbar-menu-wrap .navbar-collapse').css('margin-top', '160px');
  //   }
  // }

  // $('.info-banner-link').click(function(){
  //   var thisID = '#' + $(this).data('target');
  //   $(thisID).on('show.bs.modal', function(){
  //     // setTimeout(function(){
  //     //   $('.modal-backdrop').addClass('pd-backdrop-dark');
  //     // });
  //   }).modal('show');
  // });

  var header = $('.pd-main-menu-wrap');
  var sticky = header.offset().top;

  function stickyHeader(){
    header.toggleClass('clear', window.pageYOffset <= sticky);
  }

  // Initialize logo variations
  const magentaLogo = $('#navbarLogo').attr('src');
  const whiteLogo = new Image();
  whiteLogo.src = $('#navbarBrand').data('alt-logo');

  function toggleLogo(toggle) {
    if(toggle){
      $('#navbarLogo').attr('src', magentaLogo);
    }else{
      $('#navbarLogo').attr('src', whiteLogo.src);
    }
  }

  window.addEventListener('resize', positionNavBg);

  // Position the hidden nav background
  function positionNavBg() {
    if(window.innerWidth > 768){
      var toggle = $('.pd-menu-trigger');
      var menuLeft = 2500 - (toggle.offset().left + 36);
      $('#pdMainMenuBg').css('left', '-' + menuLeft + 'px');
    }
  }

  positionNavBg();

  var mobileNav = $('#mobileNav');
  var showSearchIcon = $('#showNavSearch');
  var closeSearchIcon = $('#closeNavSearch');
  var navSearchInput = $('#navSearchInput');

  $('.show-search').click(function(){
    var searchOpen = mobileNav.hasClass('show-search');
    mobileNav.toggleClass('show-search', !searchOpen);
    closeSearchIcon.toggle(!searchOpen);
    $('.pd-main-menu-wrap').toggleClass('expand', !searchOpen);
  });

  navSearchInput.find('input').keyup(function(e){
    if(e.keyCode == 27) {
      mobileNav.removeClass('show-search');
    }
  });

  $('.pd-menu-trigger').click(function(e){
    var _this = $(this);
    e.preventDefault();
    $('.pd-main-menu-wrap').toggleClass('expand', mobileNav.hasClass('show-search'));
    mobileNav.hide();

    function closeMenu() {
      mobileNav.removeClass('show-search');
      closeSearchIcon.hide();
      $('.pd-main-menu-wrap').removeClass('expand');
      _this.text('MENU');
      toggleLogo(true);
      //$('#pd-menu-main_menu').removeClass('visible');
      $('.pd-main-menu-bg').removeClass('closing');
      mobileNav.show();
    }

    if($('body').hasClass('pd-menu-open')){
      $('#pd-menu-toolbar_menu').removeClass('show');
      $('#pd-menu-main_menu').removeClass('visible');
      $('.pd-main-menu-bg').removeClass('open').addClass('closing');
      $('.pd-main-menu-wrap').removeClass('nav-open');
      setTimeout(function(){
        closeMenu();
        if(window.innerWidth > 768){
          setTimeout(function(){
            $('body').removeClass('pd-menu-open');
          }, 1000);
        }else{
          $('body').removeClass('pd-menu-open');
        }
      }, 350);

    }else{
      _this.text('CLOSE');
      $('body').addClass('pd-menu-open');
      $('.pd-main-menu-bg').addClass('open');
      toggleLogo(false);
      setTimeout(function(){
        $('#pd-menu-main_menu').addClass('visible');
        $('#pd-menu-toolbar_menu').addClass('show');
        $('.pd-main-menu-wrap').addClass('nav-open');
        mobileNav.show();
      }, 250);
      $('.pd-mk-filters .dropdown-menu').hide();
    }
  });

  $(function () {
    $('[data-toggle="popover"]').popover({
      trigger: 'focus'
    });
  });

  $('.pd-mk__footer-contact').children().each(function(){
    $(this).html($(this).html().replace(/\u8232/g," "));
  });

  $('.container-rewrap').each(function(){
    var content = $(this).children().clone();
    var container = $('<div>').addClass('container py-lg-5');
    container.append(content);
    $(this).empty().append(container);
  });

  function replaceRBalls(elem) {
    $(elem).html(function(i, html) {
      return html.replace(/\u00ae/g, "<sup>&reg;</sup>").replace('®', "<sup>&reg;</sup>");
    });
  }

  $('.pd-mk-departments__content, .pd-mk__news-item, .pd-mk-post, .pd-mk-pipeline__product-name').each(function(i, elem) {
    replaceRBalls(elem);
  });

  if(window.innerWidth > 768){
    $('.pd-collapse-trigger').each(function(i, elem){
      replaceRBalls(elem);
    });
  }

  if($('#mkPipeline').length){
    function setGraphWidth(line, className) {
      switch(className){
        case 'pre-ind':
          line.css('width', Math.floor($('#mkPipeline').width() * 0.15) + 'px');
          break;
        case 'pre-ind-complete':
          line.css('width', Math.floor($('#mkPipeline').width() * 0.22 - 14) + 'px');
          break;
        case 'phase1':
          line.css('width', Math.floor($('#mkPipeline').width() * 0.27 - 6) + 'px');
          break;
        case 'phase1-complete':
          line.css('width', Math.floor($('#mkPipeline').width() * 0.33 - 12) + 'px');
          break;
        case 'phase2':
          line.css('width', Math.floor($('#mkPipeline').width() * 0.38 - 6) + 'px');
          break;
        case 'phase2-complete':
          line.css('width', Math.floor($('#mkPipeline').width() * 0.44 - 10) + 'px');
          break;
        case 'phase3':
          line.css('width', Math.floor($('#mkPipeline').width() * 0.49 - 6) + 'px');
          break;
        case 'phase3-complete':
          line.css('width', Math.floor($('#mkPipeline').width() * 0.55 - 8) + 'px');
          break;
        case 'approved':
          line.css('width', Math.floor($('#mkPipeline').width() * 0.66 - 6) + 'px');
          break;
        case 'approved-complete':
          line.css('width', Math.floor($('#mkPipeline').width() * 0.66 - 6) + 'px');
          break;
        default:
          break;
      }
    }
    if(isIE){
      $('.pd-mk-pipeline__graph-line').css('animation', 'none');
      $('.pd-mk-pipeline__graph-bar').each(function(){
        var thisGraph = $(this).find('.pd-mk-pipeline__graph-line');
        setGraphWidth(thisGraph, $(this).data('phase'));
      });
    }else{
      document.documentElement.style.setProperty('--pipelineTableWidth', $('#mkPipeline').width() + 'px');
      $('#mkPipeline').on('inview', function(){
        setTimeout(function(){
          $('.pd-mk-pipeline__graph-bar').addClass('animate');
        }, 1000);
      });
    }
  }

  function parseNewsItems(template, dataSet, output, type) {
    output.empty();
    var limit = parseInt(dataSet.data('limit'));
    var newsTemplate = template.html();
    var templateScript = Handlebars.compile(newsTemplate);

    var newsContext = JSON.parse(dataSet.text()).data;
    for(var i=0; i<limit; i++){
      var categories = "", delimiter = "";
      for(var j=0; j<newsContext[i].categories.length; j++){
        if(j > 0){
          delimiter = ", "
        }
        categories += delimiter + string_to_slug(newsContext[i].categories[j].title);
      }
      newsContext[i].link['hostedUrl'] = newsContext[i].link.hostedUrl.replace('http:', 'https:');
      if(newsContext[i].thumbnail){
        newsContext[i].thumbnail['url'] = newsContext[i].thumbnail.url.replace('http:', 'https:');
      }
      if(categories.length > 0 && categories != undefined){
        newsContext[i]['categories'] = categories;
      }
      if(type == 'events'){
        var timestamp = Date.parse(newsContext[i].startDate.dateUTC);
        if(newsContext[i].summary){
          newsContext[i]['summary'] = newsContext[i].summary.substring(0, 155);
        }
      }else{
        var timestamp = Date.parse(newsContext[i].releaseDate.dateUTC);
        if ( newsContext[i].teaser !== null ) {
          newsContext[i]['teaser'] = newsContext[i].teaser.substring(0, 155) + ' ...';
        } else {
          newsContext[i]['teaser'] = null;
        }
      }
      timestamp = new Date(timestamp);
      var month = new Intl.DateTimeFormat('en-US', {month: 'long'}).format(timestamp);
      newsContext[i]['timestamp'] = month + " " + timestamp.getDate() + ", " + timestamp.getFullYear();
      var newsItem = templateScript(newsContext[i]);
      output.append(newsItem);
    }
  }

  if($('#newsItems').length){
    parseNewsItems($('#newsItemTemplate'), $('#newsItems'), $('#newsSlider'), 'news');
    $('#newsSlider').collapse('show');
    if(isIE){
      $('#newsSlider').on('shown.bs.collapse', function(){
        $('#newsSlider').css('min-height', $('#newsSlider').height() + 'px');
      });
    }
    $('.dropdown-collapse').click(function(e){
      e.preventDefault();
      var _thisCollapse = $($(this).data('target'));
      if(!$(this).hasClass('active')){
        $('.collapse').collapse('hide'); //.css('min-height', '0');
        $('.dropdown-collapse').removeClass('active');
        $(this).addClass('active');
        _thisCollapse.collapse('show');
        $('#newsFilterLabel').text($(this).text());
        if(isIE){
          _thisCollapse.on('shown.bs.collapse', function(){
            _thisCollapse.css('min-height', _thisCollapse.height() + 'px');
          });
        }
      }
      $(this).parent().hide();
    });
    renderSlider();
  }

  if($('#eventsItems').length){
    parseNewsItems($('#newsItemTemplate'), $('#eventsItems'), $('#eventsSlider'), 'events');
  }

  function renderSlider(){
    if($('#newsSlider').length){
      // if(window.innerWidth < 769){
      //   var newSlide = $('#newsSlider').find('.pd-mk__news-col--empty').last().clone();
      //   $('#newsSlider').append(newSlide);
      // }

      // News & Events slider
      $('.news-slider').slick({
        focusOnSelect: true,
        infinite: false,
        slidesToShow: 4,
        slidesToScroll: 1,
        appendArrows: '.news-slider__arrows',
        responsive: [
          {
            breakpoint: 992,
            settings: {
              slidesToShow: 2
            }
          },
          {
            breakpoint: 567,
            settings: {
              slidesToShow: 1
            }
          }
        ]
      });

      $('.pd-mk__news-item').matchHeight();
    }
  }

  // Careers
  $('.career-values__graph-column').hover(function(){
    $(this).find('dd').slideDown();
  }, function(){
    $(this).find('dd').slideUp();
  });

  if(window.innerWidth < 768){
    $('.career-values__slider').slick({
      focusOnSelect: true,
      infinite: false,
      slidesToShow: 1,
      slidesToScroll: 1
    });
  }

  // Testimonial Slider (Tabs Version)
  // $('.pd-quote-slider').slick({
  //   focusOnSelect: false,
  //   slidesToShow: 1,
  //   slidesToScroll: 1,
  //   infinite: true,
  //   fade: true,
  //   arrows: false,
  //   dots: true,
  // }).on('setPosition', function (event, slick) {
  //   matchStyle();
  // });
  // $('.pd-tabs a[data-toggle="tab"]').on('shown.bs.tab', function (e) {
  //   $('.pd-quote-slider').slick('setPosition');
  // });

  $('.pd-tabs a[data-toggle="tab"]').on('shown.bs.tab', function(event) {
    if (event.target.id === 'fellowships-tab') {
      $('[aria-labelledby="' + event.target.id + '"]').find('.pd-quote-slider').slick({
        focusOnSelect: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
        fade: true,
        arrows: false,
        dots: true
      }).on('setPosition', function (event, slick) {
        matchStyle();
      });
    }
  });

  // Testimonial Slider
  $('.testimonial-quote-slider').slick({
    focusOnSelect: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    asNavFor: '.testimonial-control-slider',
    infinite: true,
    arrows: true,
    fade: true
  });

  $('.testimonial-control-slider').slick({
    focusOnSelect: true,
    centerMode: false,
    asNavFor: '.testimonial-quote-slider',
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: false,
    autoplay: true,
    responsive: [
      {
        breakpoint: 567,
        settings: {
          centerMode: true,
          slidesToShow: 1,
          adaptiveHeight: true
        }
      }
    ]
  });

  // Careers Slider
  $('.pd-careers-slider .blocks-gallery-grid').slick({
    focusOnSelect: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    infinite: true,
    arrows: true,
    fade: true,
    dots: true
  });

  $('.pd-image-slider .blocks-gallery-grid').slick({
    focusOnSelect: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    infinite: true,
    arrows: false,
    fade: true,
    dots: true,
    autoplay:true
  });

  $('.pd-mk-jobs__table a').click(function(e){
    e.preventDefault();
    window.open($(this).attr('href'));
  })

  if($('#historyCarousel').length){
    // About page timeline slider
    if(window.innerWidth < 567){
      $('.item-even').each(function(){
        var time = $(this).find('time').clone();
        $(this).find('time').remove();
        $(this).append(time);
      });
    }

    $('.pd-mk-history__timeline').slick({
      focusOnSelect: false,
      slidesToShow: 4,
      slidesToScroll: 3,
      appendArrows: '.pd-mk-history__arrows',
      infinite: false,
      fade: false,
      responsive: [
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 567,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
      ]
    });
  }

  // Team & filters
  $('.pd-mk-modal--open').click(function(){
    var modalContainer = $('#modalContainer');
    //modalContainer.addClass('pd-team-modal');
    if($(this).data('target') != undefined){
      var modalParent = $($(this).data('target'));
    }else{
      if($(this).hasClass('wp-block-image')){
        var modalParent = $($(this).find('img').attr('title'));
      }else{
        var modalParent = $($(this).attr('title'));
      }
    }
    var modalContent = modalParent.children().clone();
    modalContent.find('.close').click(function(){
      $('body').removeClass('modal-open');
      modalContainer.empty();
    });
    modalContainer.empty().append(modalContent);
    setTimeout(function(){
      modalContainer.addClass('modal-shown');
    }, 500);
    $('body').addClass('modal-open').keyup(function(e){
      if(e.keyCode == 27) {
        $('body').removeClass('modal-open');
      }
    });
  });

  $('.pd-mk-filters .dropdown-toggle').click(function(e){
    e.preventDefault();
    $(this).parent().find('.dropdown-menu').toggle();
  });

  function filterItems(term) {
    var members = $('.pd-mk-filter__item');
    if(term == 'all'){
      $('.pd-mk-filter__item').parent().show();
      $('.pd-mk-filter__item').animate({
        opacity: 1
      }, 250);
    }else{
      members.each(function(){
        var memberWrapper = $(this).parent();
        var filterSlug = $(this).data('filter-list');
        if(filterSlug != term){
          $(this).animate({
            opacity: 0
          }, 250, function(){
            memberWrapper.hide();
          });
        }else{
          memberWrapper.show();
          $(this).animate({
            opacity: 1
          }, 250);
        }
      });
    }
  }

  $('.dropdown-filter').click(function(){
    filterItems($(this).data('filter'));
    $('.pd-mk-filters').find('.dropdown-menu').hide();
  });

  if($('.pd-mk-history__arrows').length){
    var index = parseInt($('#historyCarousel').data('index'));
    var limit = 3, direction = 'forward';

    function moveHistory(direction){
      if(direction == 'forward' && index <= 2){
        index++;
      }else if(direction == 'back' && index >= 2){
        index--;
      }
      $('#historyCarousel').data('index', index).attr('class', 'container pd-mk-history__carousel pos' + index);
    }

    $('.pd-mk-history__arrows .nav-arrow').click(function(){
      direction = $(this).hasClass('nav-arrow--next') ? 'forward' : 'back';
      moveHistory(direction);
    });
  }

  function minHeightIE() {
    $('.row').each(function(){
      $(this).css('min-height', $(this).height() + 'px');
    });
  }

  if(isIE){
    minHeightIE();
    if(window.location.pathname == '/'){
      $('.pd-mk__footer').css('margin-top', '200px');
    }
  }

  // Match CSS
  function matchStyle() {
    $(".pd-careers-slider").css({"margin-top": $(".pd-main-menu-wrap").outerHeight() + $(".info-banner").outerHeight() });
    $("body.page-id-85").css({"margin-top": $(".pd-main-menu-wrap").outerHeight() + $(".info-banner").outerHeight() });
    $(".pd-quote-slider .slick-slide li").css({"height": $(".pd-quote-slider .slick-slide").outerWidth() });
    $(".pd-quote-slider .slick-slide").css({"height": $(".pd-quote-slider .slick-slide").outerWidth() });
    $(".pd-image-slider .slick-slide li").css({"height": $(".pd-image-slider .slick-slide").outerWidth() });
  }

  // Let's debounce our heavy lifts
  // https://css-tricks.com/snippets/jquery/done-resizing-event/
  var resizeTimer;

  // on load inside document ready doesn't work reliably in 3.0 so we're doing it both ways!
  // https://github.com/jquery/jquery/issues/3194
  matchStyle();

  $(window).on('load',function(){
    //console.log('on load fired');
    matchStyle();
  });

  $(window).on('resize', function(e) {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function() {
      // Run code here, resize has "stopped"
      matchStyle();
    }, 250);
  });

});
